<template>
  <a-layout style="background: #fff">
    <Header />
    <div class="header-title">
      <span>短信字数判断</span>
    </div>
    <div class="container">
      <a-form style="text-align: center">
        <a-form-item>
          <a-textarea
            size="large"
            v-model="text"
            allow-clear
            placeholder="短信内容，记得签名"
            rows="20"
          />
        </a-form-item>
      </a-form>
      <div>
        <a-tag color="green">字数：{{ text.length }}</a-tag>
      </div>
      <div>
        <p>一般计费规则</p>
        <p><b>短信字数 ≤ 70个字</b>  按照70个字一条短信计算，中文、英文、符号统一计算一个字符</p>
        <p><b>短信字数 > 70个字</b>  按照67个字一条短信计算，其中3个字占用为分条字符</p>
      </div>
      <div>
        <p>注意事项</p>
        <p>1. 短信计费标准以短信服务提供商为准，以上计费规则仅供参考。</p>
        <p>2. 短信长度判断仅考虑短信内容的字符数，不考虑短信服务提供商的其他费用。</p>
        <p>3. 网页地址<b>前、后</b>均需要加空格，避免手机识别错误</p>
        <p>4. 需要用【】标记签名</p>
        <p>5. 会员营销需要增加结尾「，拒收请回复R」</p>
      </div>
    </div>
    <Footer />
  </a-layout>
</template>

<script>
import Footer from "../components/Footer";
import Header from "../components/Header";


export default {
  name: "Quote",
  props: {
    query: String,
  },
  components: {
    Footer,
    Header,
  },
  data() {
    return {
      total_urls: 0,
      process_count: 0,
      loading: false,
      text: "",
      result_text: "",
    };
  },
  mounted () {
    if(this.query) {
      this.text = this.query
    }
    document.title = "不便利 - 短信字数判断"
  },
  watch: {},
  computed: {},
  methods: {
    // pass
  },
};
</script>

<style scoped lang="less">



</style>
